import React, { useEffect, useRef, useState } from 'react';

import {
  Button,
  Icon,
  Input,
  Layout,
  message,
  Modal,
  Table,
  Upload,
} from 'antd';

import pos from 'pos-api';
import { Link } from 'react-router-dom';
import posv2 from '../../../lib/posv2';

const { Search } = Input;

const { Content } = Layout;

function retrieveDiscountDescription(discount) {
  let data = discount;

  if (discount.type === 'all') {
    return '全部折抵';
  } else if (discount.type === 'hourly') {
    let messages = [];

    let hours;

    if (data.default_hours != null) {
      hours = data.default_hours;
    }

    if (!hours) return '';

    return `折抵${hours}小時`;
  } else if (discount.type === 'amount') {
    if (data.default_amount) {
      return `折抵${discount.amount}元`;
    }
  }

  return '';
}

const columns = [
  {
    title: '名稱',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: '車號',
    dataIndex: 'plate',
    key: 'plate',
    render: (plate, record) => {
      let identities = record.identities;
      if (!identities) return '';

      let plates = identities.filter(idt =>
        ['plate_car', 'plate_moto'].includes(idt.type)
      );

      return plates.map(p => p.content).join(',');
    },
  },
  {
    title: '優惠折扣',
    dataIndex: 'discounts',
    key: 'discounts',
    render: (discounts, record) => {
      if (!discounts) return '';

      return discounts.map(dis => dis.name).join(',');
    },
  },
  {
    title: '動作',
    dataIndex: 'action',
    key: 'action',
    render: (act, record) => {
      return (
        <span>
          <Link to={`/dashboard/manage/customer/${record.id}`}>
            <Button type='link' icon='edit'></Button>
          </Link>

          {/* <Button
            type='danger'
            icon='delete'
            style={{
              marginLeft: '6px',
            }}
          ></Button> */}
        </span>
      );
    },
  },
];

const Customers = props => {
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 20,
    total: 100,
  });

  const [customers, setCustomers] = useState([]);

  const searchRef = useRef();

  const [searchText, setSearchText] = useState('');

  const [selectedKeys, setSelectKeys] = useState([]);

  const [state, setState] = useState('view');

  useEffect(() => {
    if (pagination.current < 1) return;

    async function init() {
      if (state !== 'view') {
        return;
      }

      let resp = await pos.customer.readCustomers({
        pageSize: pagination.pageSize,
        page: pagination.current - 1,
        identity: searchText,
      });

      resp.content?.forEach(c => {
        c.key = c.id;
      });

      setCustomers(resp.content);

      setPagination({
        current: pagination.current,
        pageSize: Number(resp.pagination.page_size),
        total: resp.pagination.total_elements,
      });
    }

    init();
  }, [pagination.current, state]);

  useEffect(() => {
    setPagination({
      ...pagination,
      current: 0,
    });

    // hack
    setTimeout(() => {
      setPagination({
        ...pagination,
        current: 1,
      });
    }, 50);
  }, [searchText]);

  const handleTableChange = pagination => {
    setPagination(pagination);
  };

  const handleImport = async file => {
    let hide = message.loading('處理中...');
    try {
      await pos.customer.importCustomers(file);
    } catch (err) {
      hide();
      console.log(err);
      message.error('處理失敗');
      return;
    }

    hide();
    message.success('處理成功');
  };

  const onSearch = text => {
    console.log('log');
    if (searchRef.current) {
      clearTimeout(searchRef.current);
    }

    searchRef.current = setTimeout(() => {
      setSearchText(text);
    }, 250);
  };

  const onDelete = async () => {
    try {
      await posv2.deleteCustomers(selectedKeys);
    } catch (err) {
      console.error(err);
    }

    setState('view');
  };

  return (
    <div>
      <div
        style={{
          padding: '0px 16px',
        }}
      >
        <Content
          style={{
            margin: '12px 0px 16px 0px',
            padding: '24px',
            background: '#fff',
            minHeight: 80,
          }}
        >
          <div style={{ float: 'left' }}>
            <Link to='/dashboard/manage/customer/0'>
              <Button type='link' icon='plus'>
                新增顧客
              </Button>
            </Link>

            <div
              style={{
                display: 'inline-block',
              }}
            >
              <Upload
                {...{
                  accept: '.csv',
                  beforeUpload: file => {
                    handleImport(file);

                    return false;
                  },
                  fileList: [],
                }}
              >
                <Button type='link'>
                  <Icon type='import' />
                  匯入
                </Button>
              </Upload>
            </div>

            <Button
              type='link'
              icon='delete'
              onClick={evt => {
                Modal.confirm({
                  title: '刪除資料',
                  onOk: () => {
                    onDelete();
                  },
                });

                setState('delete');
              }}
            >
              刪除
            </Button>
          </div>

          <div style={{ float: 'right' }}>
            <Search
              placeholder={'請輸入車牌號碼'}
              onSearch={onSearch}
              onChange={evt => {
                let value = evt.target.value;
                if (value == null) return;

                onSearch(value);
              }}
              style={{ width: 200 }}
            />
          </div>
        </Content>
      </div>

      <Content
        style={{
          margin: '24px 16px',
          padding: 24,
          background: '#fff',
          minHeight: 280,
        }}
      >
        <Table
          columns={columns}
          dataSource={customers}
          pagination={pagination}
          onChange={handleTableChange}
          rowSelection={{
            onChange: selectedRowKeys => {
              setSelectKeys(selectedRowKeys);
            },
          }}
        />
      </Content>
    </div>
  );
};

export default Customers;
